 /* Pool cards remain in inert templates: Sleek's live [name=id] query sees only displayed cards. */
if (!customElements.get('lw-bundle-shuffle')) {
  customElements.define('lw-bundle-shuffle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const start = () => {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        const bundle = this.closest('products-bundle');
        const button = bundle.querySelector('[data-shuffle-cart]');
        const status = this.querySelector('[data-shuffle-status]');
        const pool = [...this.querySelector('[data-shuffle-pool]').content.querySelectorAll('template[data-product-id]')];
        const list = this.querySelector('[data-shuffle-list]');
        const key = `lw-bundle:${this.dataset.section}:${this.dataset.collection}`;
        let previous = [];
        try { previous = JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (_) {}
        if (!Array.isArray(previous)) previous = [];
        // Fisher-Yates, then ensure a different group when extra products exist.
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        const chosen = pool.slice(0, 3);
        if (pool.length > 3 && chosen.every(t => previous.includes(t.dataset.productId))) {
          const replacement = pool.slice(3).find(t => !previous.includes(t.dataset.productId));
          if (replacement) chosen[2] = replacement;
        }
        if (!chosen.length) {
          status.textContent = 'No available products in this collection.';
          return;
        }
        const fragment = document.createDocumentFragment();
        chosen.forEach((template, index) => {
          const card = template.content.cloneNode(true);
          card.querySelector('.product-bundle-card__count').textContent = index + 1;
          fragment.append(card);
        });
        list.replaceChildren(fragment);
        this.querySelector('[data-shuffle-pool]').remove();
        try { sessionStorage.setItem(key, JSON.stringify(chosen.map(t => t.dataset.productId))); } catch (_) {}
        status.hidden = true;
        button.disabled = false;
        // Scope the check to the rendered list; never substitute a different size/product.
        button.addEventListener('click', event => {
          const selects = [...list.querySelectorAll('select[name="id"]')];
          const valid = selects.length === chosen.length && selects.every(select => {
            const option = select.selectedOptions[0];
            return option && !option.disabled && option.dataset.available === 'true';
          });
          if (!valid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            status.hidden = false;
            status.textContent = 'Please select an available size for each displayed product.';
          }
        }, {capture: true});
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
      else queueMicrotask(start);
    }
  });
}
